import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8ae611ea")

_pushScopeId("data-v-8ae611ea")
const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "添加选项", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_text_area = _resolveComponent("a-text-area")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_checkbox = _resolveComponent("a-checkbox")
  const _component_a_input = _resolveComponent("a-input")
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_input_number = _resolveComponent("a-input-number")
  const _component_Editor = _resolveComponent("Editor")
  const _component_a_form = _resolveComponent("a-form")

  return (_openBlock(), _createBlock(_component_a_form, { layout: "vertical" }, {
    default: _withId(() => [
      _createVNode(_component_a_form_item, { label: "题目" }, {
        default: _withId(() => [
          _createVNode(_component_a_text_area, {
            value: _ctx.dataClone.stem,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataClone.stem = $event)),
            min: 1,
            maxlength: 100,
            placeholder: "请输入信息"
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "选项" }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataClone.pMetas, (meta, metaIndex) => {
            return (_openBlock(), _createBlock("div", {
              class: "sm-item",
              key: meta.uid
            }, [
              _createVNode(_component_a_checkbox, {
                checked: _ctx.isChecked(metaIndex),
                onClick: _withModifiers(($event: any) => (_ctx.handleCheckboxChange(metaIndex)), ["stop"])
              }, null, 8, ["checked", "onClick"]),
              _createVNode(_component_a_input, {
                value: meta.meta,
                "onUpdate:value": ($event: any) => (meta.meta = $event),
                maxlength: 50,
                minlength: 1
              }, null, 8, ["value", "onUpdate:value"]),
              _createVNode(_component_DeleteOutlined, {
                class: "sm-del btn-gray",
                onClick: _withModifiers(($event: any) => (_ctx.handleDelMetaClick(metaIndex)), ["stop"]),
                type: "link",
                size: "small"
              }, null, 8, ["onClick"])
            ]))
          }), 128)),
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_a_button, {
              class: "sm-add-meta",
              block: "",
              onClick: _ctx.handleAddMetaClick,
              type: 'dashed',
              disabled: _ctx.reachMaxLimit
            }, {
              default: _withId(() => [
                _createVNode(_component_PlusOutlined),
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "题目分值" }, {
        default: _withId(() => [
          _createVNode(_component_a_input_number, {
            value: _ctx.dataClone.score,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataClone.score = $event)),
            max: 20,
            min: 1
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "解析" }, {
        default: _withId(() => [
          _createVNode(_component_Editor, {
            modelValue: _ctx.dataClone.analysis,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataClone.analysis = $event)),
            onMounted: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onEditorMounted(1, $event)))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})